export default __webpack_public_path__ + "static/media/BaseballBat_1.67db98f0.png";